import { Settings, variantProvider } from '@/app'
import { IconPlaceholder } from '@codeleap/common'
import * as LibComponents from '@codeleap/web'
import { defaultStyles } from '@codeleap/web'
import * as StyleSheets from '../app/stylesheets'
import { ActivityIndicatorCP } from './ActivityIndicator'
export * from './ComponentShowCase'
export * from './Widgets'

export const variants = {
  ...defaultStyles,
  Alert: StyleSheets.AppAlertStyles,
  Checkbox: StyleSheets.AppCheckboxStyles,
  RadioInput: StyleSheets.AppRadioInputStyles,
  Touchable: StyleSheets.AppTouchableStyles,
  Button: StyleSheets.AppButtonStyles,
  Icon: StyleSheets.AppIconStyles,
  ActivityIndicator: StyleSheets.AppActivityIndicatorStyles,
  Select: StyleSheets.AppSelectStyles,
  Text: StyleSheets.AppTextStyles,
  View: StyleSheets.AppViewStyles,
  Modal: StyleSheets.AppModalStyles,
  Drawer: StyleSheets.AppDrawerStyles,
  TextInput: StyleSheets.AppTextInputStyles,
  Image: StyleSheets.AppImageStyles,
  Link: StyleSheets.LinkStyles,
  Logo: StyleSheets.LogoStyles,
  Page: StyleSheets.PageStyles,
  Overlay: StyleSheets.AppOverlayStyles,
  List: StyleSheets.AppListStyles,
  Avatar: StyleSheets.AvatarStyles,
  CenterWrapper: StyleSheets.CenterWrapperStyles,
  Player: StyleSheets.PlayerStyles,
  StoryAvatar: StyleSheets.StoryAvatarStyles,
  ActionIcon: StyleSheets.AppActionIconStyles,
  LoadingOverlay: StyleSheets.AppLoadingOverlayStyles,
  InputBase: StyleSheets.AppInputBaseStyles,
  Switch: StyleSheets.AppSwitchStyles,
  Slider: StyleSheets.AppSliderStyles,
  NumberIncrement: StyleSheets.AppNumberIncrementStyles,
  Tooltip: StyleSheets.AppTooltipStyles,
  Badge: StyleSheets.AppBadgeStyles,
  SegmentedControl: StyleSheets.AppSegmentedControlStyles,
  Pager: StyleSheets.AppPagerStyles,
  CardBase: StyleSheets.AppCardBaseStyles,
  Navigation: StyleSheets.NavigationStyles,
  EmptyPlaceholder: StyleSheets.AppEmptyPlaceholderStyles,
  Grid: StyleSheets.AppGridStyles,
  Tag: StyleSheets.TagStyles,
  Calendar: StyleSheets.AppCalendarStyles,
  ProgressBar: StyleSheets.ProgressBarStyles,
  ProgressCircle: StyleSheets.ProgressCircleStyles,
  Header: StyleSheets.HeaderStyles,
  CropPicker: StyleSheets.AppCropPickerStyles
}
LibComponents.Select.defaultProps.clearable = true
LibComponents.Select.defaultProps.components = {
  ClearIndicator: null
}
LibComponents.SearchInput.defaultProps.searchIcon = 'search' as IconPlaceholder
LibComponents.SearchInput.defaultProps.clearIcon = 'x' as IconPlaceholder
LibComponents.ActivityIndicator.defaultProps.component = ActivityIndicatorCP as () => JSX.Element
LibComponents.List.defaultProps.refresh = false
LibComponents.Grid.defaultProps.refresh = false

LibComponents.List.defaultProps.overscan = 9
LibComponents.Grid.defaultProps.overscan = 9

LibComponents.Touchable.defaultProps.analyticsEnabled = true
LibComponents.CropPicker.defaultProps = {
  targetCrop: Settings.Images.default,
  withLoading: true,
  accept: 'image/*'
}

LibComponents.Modal.defaultProps.scrollLock = true
LibComponents.Modal.defaultProps.autoIndex = true

const components = variantProvider.typeComponents({
  View: [LibComponents.View, variants.View],
  Icon: [LibComponents.Icon, variants.Icon],
  Text: [LibComponents.Text, variants.Text],
  Touchable: [LibComponents.Touchable, variants.Touchable],
  Scroll: [LibComponents.Scroll, variants.Scroll],
  ActivityIndicator: [LibComponents.ActivityIndicator, variants.ActivityIndicator],
  Button: [LibComponents.Button, variants.Button],
  ActionIcon: [LibComponents.ActionIcon, variants.ActionIcon],
  Modal: [LibComponents.Modal, variants.Modal],
  Checkbox: [LibComponents.Checkbox, variants.Checkbox],
  RadioInput: [LibComponents.RadioGroup, variants.RadioInput],
  SegmentedControl: [LibComponents.SegmentedControl, variants.SegmentedControl],
  Select: [LibComponents.Select, variants.Select],
  TextInput: [LibComponents.TextInput, variants.TextInput],
  Overlay: [LibComponents.Overlay, variants.Overlay],
  FileInput: [LibComponents.FileInput, {}],
  List: [LibComponents.List, variants.List],
  Drawer: [LibComponents.Drawer, variants.Drawer],
  LoadingOverlay: [LibComponents.LoadingOverlay, variants.LoadingOverlay],
  InputBase: [LibComponents.InputBase, variants.InputBase],
  Switch: [LibComponents.Switch, variants.Switch],
  Slider: [LibComponents.Slider, variants.Slider],
  NumberIncrement: [LibComponents.NumberIncrement, variants.NumberIncrement],
  Tooltip: [LibComponents.Tooltip, variants.Tooltip],
  Badge: [LibComponents.Badge, variants.Badge],
  Pager: [LibComponents.Pager, variants.Pager],
  EmptyPlaceholder: [LibComponents.EmptyPlaceholder, variants.EmptyPlaceholder],
  Grid: [LibComponents.Grid, variants.Grid],
  SearchInput: [LibComponents.SearchInput, variants.TextInput],
  CropPicker: [LibComponents.CropPicker, variants.CropPicker]
})

const SelectWithGenerics = LibComponents.Select as <T extends string | number = string, Multi extends boolean = false>(
  props: LibComponents.SelectProps<T, Multi>
) => JSX.Element

export const allComponents = {
  ...components,
  Select: SelectWithGenerics
}

import { Modal as CLModal } from '@codeleap/modals'

CLModal.WrapperComponent = LibComponents.Modal

export const {
  View,
  Button,
  Text,
  Icon,
  Touchable,
  ActionIcon,
  Scroll,
  ActivityIndicator,
  Modal,
  Checkbox,
  RadioInput,
  Select,
  TextInput,
  Overlay,
  LoadingOverlay,
  FileInput,
  List,
  Drawer,
  Switch,
  NumberIncrement,
  Tooltip,
  SegmentedControl,
  Pager,
  Grid,
  Slider,
  SearchInput,
  CropPicker,
  EmptyPlaceholder
} = allComponents

export * from './Achievements'
export * from './ActivityIndicator'
export * from './Alerts'
export * from './Animations'
export * from './AppStatus'
export * from './Auth'
export * from './Avatar'
export * from './Calendar'
export * from './Cards'
export * from './CenterWrapper'
export * from './Contribute'
export * from './CropPickerModal'
export * from './DynamicPageHandler'
export * from './Feed'
export * from './FileSelect'
export * from './FilterModal'
export * from './Footer'
export * from './GlobalStyle'
export * from './Header'
export * from './HTMLRender'
export * from './Hurdle'
export * from './Image'
export * from './ImpersonatingBanner'
export * from './LanguageSelector'
export * from './Link'
export * from './LoadingScreen'
export * from './Logo'
export * from './Modals'
export * from './MyAvatar'
export * from './Navigation'
export * from './OnboardingQuestions'
export * from './Page'
export * from './PageGradientTop'
export * from './Placeholder'
export * from './Player'
export * from './Player/Fullscreen'
export * as PlayerYoutube from './PlayerYouTube'
export * from './PostCard'
export * from './ProfileAvatar'
export * from './Progress'
export * from './ProgressBar'
export * from './Scores'
export * from './SearchLabel'
export * from './SEO'
export * from './ShareButton'
export * from './SliderOnboarding'
export * from './StoreButton'
export * from './Stories'
export * from './Tag'
export * from './TopImageWrapper'
export * from './WorkingAt'

export default components
